import { useEffect, useState, useRef  } from 'react';
import { Col, Row, Table } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import { SelfSummaryService } from '../../services/SelfSummaryService';
import * as BullCache from "../../util/BullCache";
import NumberFormatter from "../components/NumberFormatter";
import html2canvas from "html2canvas";
import jsPDF from 'jspdf';

function Selfsummary() {

  const pdfRef = useRef();
  const [summaryList, setSummaryList] = useState([]);
  const [summary, setSummary] = useState([]);
  const [date, setDate] = useState([]);
  const [week, setWeek] = useState([]);

  var user = BullCache.getFromCache("user");
  
  useEffect(() => {
    SelfSummaryService.getSelfSummary({ 'adminId': user.adminId }).then(res => {
      if (res.code === 1) {
        if (res.data?.summary?.summaryList?.length > 0) {
          setSummaryList(res.data.summary.summaryList);
          setSummary(res.data.summary);
        }
        setDate(res.data?.summary?.valanDate);
        setWeek(res.data?.summary?.currentWeek);
      }
      else{
        alert('Something Went to Wrong');
      }

    });
  }, []);

   const exportToPDF = () => {
          const input = pdfRef.current;
          html2canvas(input, { scale: 2 }).then((canvas) => {
              const imgData = canvas.toDataURL("image/png");
              const pdf = new jsPDF("p", "mm", "a4");
              const imgWidth = 210; // A4 width in mm
              const imgHeight = (canvas.height * imgWidth) / canvas.width; // Maintain aspect ratio
              const paddingTop = 20; // Space after the title
              pdf.setFontSize(12); // Set title font size
              pdf.text(process.env.REACT_APP_NAME, 105, 15, { align: "center" }); // Centered title
      
              pdf.addImage(imgData, "PNG", 0, paddingTop, imgWidth, imgHeight);
              pdf.save("selfsummary.pdf");
          });
      };

  return (
    <Card className=" ms-1 me-1" style={{ fontFamily: "sans-serif" }}>
      <Card.Body className="ps-1 pe-1 white-background">
        <Row>
          <Col className='text-end'>
            {/* <Button variant="success" size="sm">
              CSV
            </Button>{' '} */}
            <Button variant="success" size="sm"  onClick={exportToPDF}>
              SAVE
            </Button>
          </Col>
        </Row>
        <div ref={pdfRef} style={{ marginTop: "10px"}}>
        <Table className="mt-1   dotted-border" responsive>
          <thead className=" white-row">
            <tr >
              <th className="fss-08 text-start white-back">Self summary</th>
              <th className="fss-08 text-center white-back">{week}</th>
              <th className="fss-08 text-end white-back">{date}</th>
            </tr>
          </thead>
          <tbody className='p-0'>
            <tr className='p-0'>
              <td colSpan={12} className='p-0'>

                <Table bordered hover className='m-0 p-0 bg-thead' >
                  <thead className=' text-black  '>
                    <tr>
                      <th className='text-black fss-08 '>Market Name</th>
                      <th className='text-black fss-08'>Script Name </th>
                      <th className='text-black text-end fss-08'>Buy Qty</th>
                      <th className='text-black text-end fss-08'>Buy Avg.Rate</th>
                      <th className='text-black text-end fss-08'>Sell Qty</th>
                      <th className='text-black text-end fss-08'>Sell Avg.Rate</th>
                      <th className='text-black text-end fss-08'>Net Qty</th>
                      <th className='text-black text-end fss-08'>Self Qty</th>
                      <th className='text-black text-end fss-08'>LIVE</th>
                      <th className='text-black text-end fss-08'>Self M2M</th>
                      <th className='text-black text-end fss-08'>Downline M2M</th>
                      <th className='text-black text-end fss-08'>Upline M2M</th>
                      <th className='text-black text-end fss-08'>Total M2M</th>

                    </tr>
                  </thead>

                  <tbody className='white-row '>
                  {summaryList.length > 0 ?
                    summaryList.map((ss) => {
                      const fontColorClass = ss.netQty > 0 ? 'positive-amout-color' : 'nagative-amout-color';
                      return (
                        <tr>
                          <td className='fss-08 text-black'>{ss.market}</td>
                          <td className='fss-08 text-black'>{ss.scriptName}</td>
                          <td className='text-end fss-08 text-black'>{ss.buyQty}</td>
                          <td className='text-end fss-08 text-black'><NumberFormatter number={ss.buyAverageRate} /></td>
                          <td className='text-end fss-08 text-black'>{ss.sellQty}</td>
                          <td className='text-end fss-08 text-black'><NumberFormatter number={ss.sellAverageRate} /></td>
                          <td className={`text-end fss-08 text-black ${fontColorClass}`}>{ss.netQty}</td>
                          <td className={`text-end fss-08 text-black ${fontColorClass}`}>{ss.selfQty}</td>
                          <td className='text-end fss-08 text-black'>{ss.ltp}</td>
                          <td className='text-end fss-08 text-black'><NumberFormatter number={ss.selfMtm} /></td>
                          <td className='text-end fss-08 text-black'><NumberFormatter number={ss.downMtm}/></td>
                          <td className='text-end fss-08 text-black'><NumberFormatter number={ss.upMtm}/></td>
                          <td className='text-end fss-08 text-black'><NumberFormatter number={ss.totalMtm}/></td>
                        </tr>);
                    })
                    :
                    <tr>
                      <td colSpan="14" className="text-center">No data available</td>
                    </tr>
                  }
                  </tbody>

                  <tfoot>
                  {summaryList.length > 0 ?
                    
                        <tr>
                          <td className='text-black fss-08 bg-thead' >Total</td>
                          <td className='text-black fss-08 bg-thead' ></td>
                          <td className='text-end text-black fss-08 bg-thead' >{summary.totalBuyQty}</td>
                          <td className='text-end text-black fss-08 bg-thead' ></td>
                          <td className='text-end text-black fss-08 bg-thead' >{summary.totalSellQty}</td>
                          <td className='text-end text-black fss-08 bg-thead' ></td>
                          <td className='text-end text-black fss-08 bg-thead' >{summary.totalNetQty}</td>
                          <td className='text-end text-black fss-08 bg-thead' >{summary.totalSelfQty}</td>
                          <td className='text-end text-black fss-08 bg-thead' ></td>
                          <td className='text-end text-black fss-08 bg-thead' ></td>
                          <td className='text-end text-black fss-08 bg-thead' ></td>
                          <td className='text-end text-black fss-08 bg-thead' ></td>
                          <td className='text-end text-black fss-08 bg-thead' ></td>
                        </tr>
                    : ''}
                  </tfoot>
                </Table>
              </td>
            </tr>
          </tbody>
        </Table>
                    </div>
      </Card.Body>
    </Card>
  );
}

export default Selfsummary;
